import { Typography } from "@fullscript/aviary-web";

import * as styles from "./PromoSlide.styles";

interface Props {
  backgroundColor: string;
  bannerImageUrl: string;
  bannerImage2xUrl: string;
  headline: string;
  subtext: string;
}

const PromoSlide = ({
  backgroundColor,
  bannerImageUrl,
  bannerImage2xUrl,
  headline,
  subtext,
}: Props) => (
  <div css={theme => styles.slide(theme, backgroundColor)}>
    <div css={styles.content}>
      <img
        src={bannerImageUrl}
        srcSet={`${bannerImageUrl}, ${bannerImage2xUrl} 2x`}
        alt=""
        css={styles.banner}
        draggable={false}
      />
      <div css={styles.textStack}>
        <Typography variant="h3" intention="inverse" isMarginless>
          {headline}
        </Typography>
        <Typography variant="footnote" intention="inverse" isMarginless>
          {subtext}
        </Typography>
      </div>
    </div>
  </div>
);

export { PromoSlide };
